module.exports = __webpack_public_path__ + "static/media/01_tn.3734ce3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/01_tn.jpg
// module id = 490
// module chunks = 0